<template>
  <GStepGrid
    class="bg-gray-10 min-h-screen"
    hide-buttons
  >
    <template #content>
      <div class="flex flex-col gap-lg items-center mt-xl">
        <section
          class="flex flex-col w-full p-lg bg-white rounded-md shadow-sm h-fit "
        >
          <g-image name="global66" size="lg" class="mb-md mx-auto" />
  
          <h3 class="text-8 text-center text-primary-txt font-semibold mb-xl">
            Estado de tu transacción
          </h3>

          <GSkeleton :loading="isLoading" animated width="20rem" height="20rem" class="rounded-full">
            <template #default>
              <p
                class="text-primary-txt border-b border-grey-50 text-4 font-semibold mb-sm pb-sm"
              >
                Detalle de la transacción
              </p>
      
              <dl class="flex flex-col divide-y divide-dashed">
                <div v-if="detailKushki.amount" class="item">
                  <dt class="key">Monto</dt>
                  <dd class="value">{{ amount }}</dd>
                </div>
      
                <div v-if="detailKushkiStatus" class="item">
                  <dt class="key">Estado de la transacción</dt>
                  <dd class="value">{{ detailKushkiStatus }}</dd>
                </div>
      
                <div v-if="detailKushki.companyName" class="item">
                  <dt class="key">Nombre de su empresa</dt>
                  <dd class="value">{{ detailKushki.companyName }}</dd>
                </div>
      
                <div v-if="detailKushki.nit" class="item">
                  <dt class="key">NIT de su empresa</dt>
                  <dd class="value">{{ detailKushki.nit }}</dd>
                </div>
      
                <div v-if="detailKushki.paymentDescription" class="item">
                  <dt class="key">Descripción del pago</dt>
                  <dd class="value">{{ detailKushki.paymentDescription }}</dd>
                </div>
      
                <div v-if="detailKushkiDate" class="item">
                  <dt class="key">Fecha de la transacción</dt>
                  <dd class="value">{{ detailKushkiDate }}</dd>
                </div>
      
                <div v-if="detailKushki.traceabilityCode" class="item">
                  <dt class="key">Código de trazabilidad (CUS)</dt>
                  <dd class="value">{{ detailKushki.traceabilityCode }}</dd>
                </div>
      
                <div v-if="detailKushki.transactionId" class="item">
                  <dt class="key">Número de transacción</dt>
                  <dd class="value">{{ detailKushki.transactionId }}</dd>
                </div>
      
                <div v-if="detailKushki.bankName" class="item">
                  <dt class="key">Banco</dt>
                  <dd class="value">{{ detailKushki.bankName }}</dd>
                </div>
              </dl>
            </template>
          </GSkeleton>
        </section>
        <g-button
          class="max-w-60 w-full "
          full
          data-test="button:Ir al home"
          @click="onHome"
        >
          Ir al home
        </g-button>
      </div>
    </template>
  </GStepGrid>
</template>

<script lang="ts" setup>
import { GButton } from '@flash-global66/g-button';
import GStepGrid from '@/components/GStepper/components/GStepGrid.vue'
import { GImage } from '@flash-global66/g-image';
import { GSkeleton } from '@flash-global66/g-skeleton';
import { useKushkiTransactionStatus } from './useKushkiTransactionStatus';

const { amount, onHome, detailKushki, detailKushkiDate, detailKushkiStatus, isLoading } = useKushkiTransactionStatus();
</script>

<style lang="scss" scoped>
.item {
  @apply flex flex-row justify-between gap-xs py-2;
}
.key {
  @apply text-terciary-txt text-3 font-medium;
}

.value {
  @apply text-secondary-txt text-3 font-semibold text-right;
}
</style>
